@charset "UTF-8";

/* src/app/global/components/global-search/global-search.component.scss */
:host {
  line-height: 60px;
}
.cw-global-search-container {
  height: 100%;
  justify-content: flex-end;
  margin-left: auto;
}
::placeholder {
  color: var(--color-default-light);
}
:-ms-input-placeholder {
  color: var(--color-default-light);
}
::-ms-input-placeholder {
  color: var(--color-default-light);
}
.cw-global-search-arrow {
  background: var(--color-accent-light);
  position: relative;
}
.cw-global-search-arrow:after {
  border: 30px solid transparent;
  border-left: 15px solid var(--color-accent-light);
  border-right-width: 0;
  content: " ";
  left: 100%;
  position: absolute;
  top: 0;
}
.cw-global-search-icon {
  color: inherit;
  cursor: pointer;
  font-size: 2rem;
  line-height: 3;
  margin-left: 15px;
  text-align: center;
  width: 60px;
}
.cw-global-search-input {
  background-color: transparent;
  border: medium none;
  color: var(--color-default-light);
  font-size: 1.6rem;
  margin-left: 15px;
  margin-right: 15px;
}
.cw-global-search-input:focus {
  border: none;
  outline: 0;
}
/*# sourceMappingURL=global-search.component.css.map */
